// count number
jQuery(document).ready(function () {
  function animateCounter($el, target) {
    jQuery({ countNum: 0 }).animate(
      { countNum: target },
      {
        duration: 2000,
        easing: 'swing',
        step: function() {
          $el.text(Math.floor(this.countNum).toLocaleString("de-DE"));
        },
        complete: function() {
          $el.text(this.countNum.toLocaleString("de-DE"));
        }
      }
    );
  }
  function startCounters() {
    jQuery('.counter').each(function(){
      var $this = jQuery(this);
      var target = parseInt($this.data('target'));
      if(!$this.hasClass('counted') && jQuery(window).scrollTop() + jQuery(window).height() > $this.offset().top){
        animateCounter($this, target);
        $this.addClass('counted');
      }
    });
  }
  jQuery(window).on('scroll', startCounters);
  startCounters();
});